import { appsNavTree } from 'configs/NavigationConfig';
import { useEffect, useState } from 'react';
import { createContext } from 'react';

export const NavigationContext = createContext(() => {
	const data = localStorage.getItem('user_id');

	if (data) {
		return { navigationConfig: appsNavTree };
	} else {
		return '';
	}
});

export const NavigationProvider = ({ children }) => {
	const [userType, setUserType] = useState(localStorage.getItem('user_id'));

	useEffect(() => {
		setUserType(localStorage.getItem('user_id'));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [localStorage.getItem('user_id')]);

	const [navigationConfig] = useState(() => {
		// const userType = localStorage.getItem('user_type');

		if (userType) {
			return appsNavTree;
		} else {
			return '';
		}
	}, []);

	// const [userType] = useState(() => {
	// 	return localStorage.getItem('user_type');
	// });

	return <NavigationContext.Provider value={{ navigationConfig, userType }}>{children}</NavigationContext.Provider>;
};
